module.exports = __webpack_public_path__ + "img/wherex-pay-logo.828fad76.svg";